module.exports = __webpack_public_path__ + "static/media/plumen-samuel-wilkinson.292a06cb.jpg";